import { useTranslation } from 'react-i18next';
import type { Control } from 'react-hook-form';
import { Input } from '@/components/ui/input';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';

interface BankInfoFieldsProps {
  // eslint_disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
}

export function BankInfoFields({ control }: BankInfoFieldsProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-2.5">
      <h1 className="text-xl font-semibold">{t('bankInfo')}</h1>
      <FormField
        control={control}
        name="bankName"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('bankName')}</FormLabel>
            <FormControl>
              <Input {...field} value={field.value ?? ''} />
            </FormControl>
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name="bankCode"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('bankCode')}</FormLabel>
            <FormControl>
              <Input {...field} value={field.value ?? ''} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name="bankAccountNumber"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('bankAccountNumber')}</FormLabel>
            <FormControl>
              <Input {...field} value={field.value ?? ''} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
